import React from 'react';
import { Box, Card, CardContent, CardHeader, Typography } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { UpcomingSubjectPaperDetail } from '../../../models/UpcomingSubjectPaper';
import { stringToSemanticDisplay } from '../../../utils/DateUtils';

const useStyles = makeStyles()((theme) =>
({
  cardHeader: {
    paddingBottom: 0,
  },
  examLevel: {
    color: theme.color.text.textHeader,
  },
  cardContent: {
    paddingTop: 0,
    paddingBottom: '4px !important',
  },
  title: {
    fontWeight: 'bold',
    margin: '8px 0',
  },
  description: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    margin: '8px 0',
    fontWeight: 400,
  },
  readMoreButton: {
    marginTop: theme.spacing(1),
    padding: 0,
    minWidth: 0,
    color: theme.color.link.linkDefault01,
    '&:hover': {
      color: theme.color.link.linkHover01,
    },
  },
  readMoreIcon: {
    flexDirection: 'row-reverse',
  },
}));

const UpcomingSubjectPapersCard = ({
  examLevel,
  subjectPaper,
  dateOfPaper,
  timeOfPaper,
}: UpcomingSubjectPaperDetail) => {
  const { classes } = useStyles();
  return (
    <Card>
      <CardHeader className={classes.cardHeader}>
        <Typography variant="subtitle2" className={classes.examLevel}>
          {examLevel}
        </Typography>
      </CardHeader>
      <CardContent className={classes.cardContent}>
        <Box minHeight={95}>
          <Typography variant="h4" className={classes.title}>
            {subjectPaper}
          </Typography>
          <IconWithLabel
            iconName={IconName.calendar}
            className={classes.description}
            gap={3}
            iconSize="S"
            typographyProps={{
              variant: 'body2',
            }}
            label={stringToSemanticDisplay(dateOfPaper)}
          />
          <IconWithLabel
            iconName={IconName.clock}
            className={classes.description}
            gap={3}
            iconSize="S"
            typographyProps={{
              variant: 'body2',
            }}
            label={timeOfPaper}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default UpcomingSubjectPapersCard;
